import { Directive, inject } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[formControlName][b2cPhoneMask]',
  host: {
    '(ngModelChange)': 'onModelChange($event)',
    '(keydown.backspace)': 'keydownBackspace($event)',
  },
})
export class PhoneMaskDirective {
  ngControl = inject(NgControl);

  onModelChange(event: unknown): void {
    this.applyInputMask(String(event ?? ''), false);
  }

  keydownBackspace(event: Event): void {
    this.applyInputMask((event.target as HTMLTextAreaElement).value, true);
  }

  /**
   * @param event Input string
   * @param backspace True if the backspace key has been pressed
   */
  applyInputMask(event: string, backspace: boolean): void {
    let result: string = event.replace(/\D/g, '');

    if (backspace && result.length <= 6) {
      result = result.substring(0, result.length - 1);
    }

    if (result.length === 0) {
      result = '';
    } else if (result.length <= 3) {
      result = result.replace(/^(\d{0,3})/, '($1)');
    } else if (result.length <= 6) {
      result = result.replace(/^(\d{0,3})(\d{0,3})/, '($1) $2');
    } else if (result.length <= 10) {
      result = result.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '($1) $2-$3');
    } else {
      result = result.substring(0, 10);
      result = result.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '($1) $2-$3');
    }

    this.ngControl?.valueAccessor?.writeValue(result);
  }
}
